import * as React from 'react';
import QRCode from 'react-qr-code';
import { Grid } from '@mui/material';
import { Button, Dialog, Text } from '.';
import AppService from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  value: string;
  link?: string;
  size?: number;
  disableMargin?: boolean;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
}

export const InputUID: React.FunctionComponent<Props> = (props) => {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(props.value);
  const [QR, setQR] = React.useState(props.link || props.value);
  const size = props.size || 135;
  
  React.useEffect( () =>  {
    if (value !== props.value) {
      const newValue = props.value || AppService.UID();
      setQR(props.link + newValue);
      setValue(newValue);
      props.onChange?.(props.name, newValue);
    }
  }, [props.value]);

  return (
    <Grid id={props.id || props.name} mt={props.disableMargin? 0 : 2} mb={props.disableMargin? 0: 3}>
      <Text label={props.label} size='small' color='text.secondary' marginBottom={1}/>
      
      <Button type='outlined' startIcon={size < 0? 'qr_code' : ''} sx={{borderRadius: 2}} onClick={() => setOpen(true)}>
        {size > 0 &&
        <Grid sx={{m: 1}}>
          <QRCode value={QR} size={size}/>
          <Text label={value} size='small' color='text.secondary' textAlign='center' marginTop={1}/>
        </Grid>
        }
      </Button>
      
      <Text label={props.error} size='small' color='red' />
      
      <Dialog open={open} maxWidth='xs' onClose={() => setOpen(false)}>
        <QRCode value={QR} size={300} />
      </Dialog>
    </Grid>    
  )
}


